// Âm thanh phản hồi khi quét (BRD §3): OK = "Ting", ERROR = "Tèeee", WARN = cảnh báo.
// Mặc định sinh âm bằng Web Audio (không cần file, phát tức thì, chồng được khi quét liên tục).
// Muốn dùng file thật: đặt public/sounds/{ting,teee,warn}.mp3 và đổi USE_FILES = true.

const USE_FILES = true;
const FILES = { OK: "sounds/scan-ting.mp3", ERROR: "sounds/scan-error.mp3", WARN: "sounds/scan-warning.mp3" };

// Âm kiểu máy quét siêu thị (loa piezo): sóng vuông, âm lượng phẳng, tắt dứt khoát.
// Chỉnh cao độ (Hz) / độ dài (giây) / âm lượng (0–1, sóng vuông rất to nên giữ thấp) tại đây.
const BEEP = {
  freq: 2700, // tiếng "bíp" quét thành công — máy quét thường 2.5–3.5kHz
  duration: 0.12,
  volume: 0.12,
};
// Cảnh báo (quét trùng / cần chú ý): "bíp-bóp" cao → thấp, khác hẳn tiếng bíp đơn khi thành công.
// Mỗi nốt phát sau nốt trước một khoảng `gap` (giây).
const WARN_NOTES = [
  // { freq: 2200, duration: 0.09, volume: 0.11 },
  { freq: [600,630], duration: 0.20, volume: 0.11, gap: 0.03 },
];
// Báo sai: còi rè "tè-eee" như máy POS. Mỗi nốt gồm 2 tần số lệch nhau ~6% nên nghe rè;
// nốt đầu ngắn hơi cao ("tè"), nốt sau trầm và dài ("eee").
const ERROR_NOTES = [
  { freq: [330, 349], duration: 0.20, volume: 0.10, gap: 0.02 },
];

let audioContext = null;
const filePlayers = {};

function getContext() {
  if (!audioContext) {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    audioContext = new Ctx();
  }
  return audioContext;
}

/** Gọi trong một thao tác người dùng (keydown/click) để trình duyệt cho phép phát âm. */
export function unlockScanSound() {
  if (USE_FILES) {
    Object.entries(FILES).forEach(([key, path]) => {
      if (!filePlayers[key]) {
        const audio = new Audio(`${process.env.PUBLIC_URL || "."}/${path}`);
        audio.preload = "auto";
        filePlayers[key] = audio;
      }
    });
    return;
  }
  const ctx = getContext();
  if (ctx && ctx.state === "suspended") ctx.resume();
}

export function isScanSoundBlocked() {
  if (USE_FILES) return false;
  const ctx = getContext();
  return !ctx || ctx.state !== "running";
}

/**
 * Một nốt. freq là số hoặc mảng (nhiều tần số phát cùng lúc — 2 tần số lệch nhau tạo tiếng rè).
 * flat = true: âm lượng giữ nguyên rồi tắt dứt khoát (kiểu máy quét);
 * flat = false: ngân nhỏ dần (kiểu chuông). Lên/xuống 5ms để không bị tiếng "tách".
 */
function tone(ctx, { freq, type = "square", start, duration, volume = 0.12, endFreq, flat = true }) {
  const gain = ctx.createGain();
  const end = start + duration;
  gain.gain.setValueAtTime(0.0001, start);
  gain.gain.exponentialRampToValueAtTime(volume, start + 0.005);
  if (flat) gain.gain.setValueAtTime(volume, Math.max(start + 0.005, end - 0.005));
  gain.gain.exponentialRampToValueAtTime(0.0001, end);
  gain.connect(ctx.destination);

  const freqs = Array.isArray(freq) ? freq : [freq];
  for (const f of freqs) {
    const osc = ctx.createOscillator();
    osc.type = type;
    osc.frequency.setValueAtTime(f, start);
    if (endFreq) osc.frequency.linearRampToValueAtTime(endFreq, end);
    // Nhiều sóng chung một gain: chia đều để tổng âm lượng không vượt `volume`.
    const share = ctx.createGain();
    share.gain.value = 1 / freqs.length;
    osc.connect(share).connect(gain);
    osc.start(start);
    osc.stop(end + 0.02);
  }
}

/** Phát lần lượt các nốt; mỗi nốt bắt đầu sau nốt trước `gap` giây. */
function playNotes(ctx, notes, start) {
  let at = start;
  for (const note of notes) {
    at += note.gap || 0;
    tone(ctx, { ...note, start: at });
    at += note.duration;
  }
}

/** @param {"OK"|"WARN"|"ERROR"} sound */
export function playScanSound(sound) {
  if (USE_FILES) {
    const player = filePlayers[sound];
    if (!player) return;
    const clone = player.cloneNode();
    clone.play().catch(() => {});
    return;
  }
  const ctx = getContext();
  if (!ctx) return;
  if (ctx.state === "suspended") ctx.resume();
  const now = ctx.currentTime;
  if (sound === "OK") {
    // "Bíp" một tiếng gọn như máy quét siêu thị.
    tone(ctx, { ...BEEP, start: now });
  } else if (sound === "WARN") {
    // "Bíp-bóp": quét trùng / cần chú ý.
    playNotes(ctx, WARN_NOTES, now);
  } else {
    // "Tè-eee": còi rè báo sai — khác hẳn tiếng bíp thành công.
    playNotes(ctx, ERROR_NOTES, now);
  }
}
